import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

// Define the structure for departments, including 'id' for content mapping
// and 'name' for display in the sidebar.
const departments = [
    { "name": "Introduction", "id": "about" },
    { "name": "Offered Courses", "id": "courses" },
    { "name": "Faculty Members", "id": "faculty" },
    { "name": "Timetable", "id": "timetable" },
    { "name": "Facilities", "id": "facilities" },
    { "name": "Seminars/Conferences/Workshops", "id": "events" },
    { "name": "Research Scholars", "id": "researchScholars" },
    { "name": "Achievements", "id": "achievements" },
    { "name": "Contact", "id": "contact" }
];

// Content for each section, mapped by their 'id'
const departmentContent = {
    "about": (
        <div>
            <p className="mb-2">The Department of Hindu Studies is dedicated to the study of Hindu religion, culture, philosophy, literature, history, and art. The department aims to develop students' comprehensive understanding of Hinduism and Hindu practices. The primary objective of the department is to study various aspects of Hinduism, impart knowledge of Hindu philosophy, Hindu cultural art, history, Indian knowledge tradition, and foundational Sanskrit language, thereby fostering an understanding of Sanatan (Hinduism) among students.</p>
            <p className="mb-2">Currently, the university offers only a Postgraduate (M.A.) program. Admission to this program requires a bachelor's degree in any subject. The course duration is two years (four semesters), with question papers in each semester. Each paper is worth 4 credits.</p>
        </div>
    ),
    "courses": (
        <div>
            <ul className="list-group list-group-flush">
                <li className="list-group-item bg-transparent border-0">Postgraduate (M.A.) Hindu Studies</li>
            </ul>
            <h6 className="mt-4 mb-2">Course Eligibility:</h6>
            <p>Bachelor's Degree in any discipline.</p>
            <p>Course Duration: 2 years (4 Semesters).</p>
        </div>
    ),
    "faculty": (
        <div className="mb-4">
            <h6 className="mb-3">1. Total Faculty - 2</h6>

            {/* Regular Faculty */}
            <h6 className="mb-2 fw-bold">Regular - 1</h6>
            <div className="table-responsive">
                <table className="table table-bordered table-striped table-hover align-middle small mb-4">
                    <thead className="table-primary text-center">
                        <tr>
                            <th>Sr. No.</th>
                            <th>Photo</th>
                            <th>Professor's Name</th>
                            <th>Designation</th>
                            <th>Highest Qualification</th>
                            <th>Contact</th>
                            <th>Email</th>
                        </tr>
                    </thead>
                    <tbody className="text-center">
                        <tr>
                            <td>1.</td>
                            <td style={{ width: "120px" }}>
                                <img
                                    src={require("../assets/Photos/डॉ. कृष्ण चन्द्र पाण्डे (विभागाध्यक्ष, हिन्दू अध्ययन).JPG")}
                                    alt="Dr. Krishna Chandra Pandey"
                                    className="img-fluid rounded"
                                    style={{ height: "100px", objectFit: "cover" }}
                                />
                            </td>
                            <td>Dr. Krishna Chandra Pandey</td>
                            <td>Head of Department, Assistant Professor</td>
                            <td>Ph.D.</td>
                            <td>98103 73278</td>
                            <td>
                                <a href="mailto:hodhindustudies@mvsu.ac.in">
                                    hodhindustudies@mvsu.ac.in
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* Contractual Faculty */}
            <h6 className="mb-2 fw-bold">Contractual - 1</h6>
            <div className="table-responsive">
                <table className="table table-bordered table-striped table-hover align-middle small">
                    <thead className="table-primary text-center">
                        <tr>
                            <th>Sr. No.</th>
                            <th>Photo</th>
                            <th>Professor's Name</th>
                            <th>Designation</th>
                            <th>Highest Qualification</th>
                            <th>Contact</th>
                            <th>Email</th>
                        </tr>
                    </thead>
                    <tbody className="text-center">
                        <tr>
                            <td>1.</td>
                            <td style={{ width: "120px" }}>
                                <img
                                    src={require("../assets/Photos/डॉ. हरीश कुमार (हिन्दु अध्ययन).jpg")}
                                    alt="Dr. Harish Kumar"
                                    className="img-fluid rounded"
                                    style={{ height: "100px", objectFit: "cover" }}
                                />
                            </td>
                            <td>Dr. Harish Kumar</td>
                            <td>Assistant Professor</td>
                            <td>Ph.D.</td>
                            <td>79883 76657</td>
                            <td>
                                <a href="mailto:rishibhawan@gmail.com">
                                    rishibhawan@gmail.com
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    ),
    "timetable": (
        <div>
            <p>Timetable related information will be available soon.</p>
        </div>
    ),
    "facilities": (
        <div>
            <ul className="list-group list-group-flush">
                <li className="list-group-item bg-transparent border-0">Students are provided with practical knowledge along with theoretical understanding.</li>
                <li className="list-group-item bg-transparent border-0">Training for various competitive examinations is provided, such as UGC NET, CTET, B.Ed., T.G.T (Sanskrit), P.G.T (Sanskrit), Dharma Guru training, etc.</li>
            </ul>
        </div>
    ),
    "events": (
        <div>
            <h6 className="mb-2 mt-4 text-secondary">* Lecture Series -</h6>
            <ol className="list-group list-group-numbered">
                <li className="list-group-item bg-transparent border-0">On March 15, 2024, a lecture series on "Shankara's Contribution to the Cultural Unity of India" was organized jointly by Maharshi Valmiki Sanskrit University, Kaithal, and Bharatiya Bhasha Samiti. The main speaker was Dr. Chitaranjan Dayal Kaushal (Director, Haryana Sahitya Sanskrit Academy Sanskrit Cell), the chief guest was Mahamandaleshwar Swami Viraganand Giri Ji, and the Chancellor of the university, Prof. Ramesh Chandra Bhardwaj Ji, presided over the event. The program was coordinated by Dr. Krishna Chandra Pandey (Head of Department, Hindu Studies).</li>
                <li className="list-group-item bg-transparent border-0">On January 25, 2025, a special program was organized on the occasion of "75 Years of the Constitution" focusing on the importance of the Indian Constitution, republican tradition, and modernity, and the goals of being proud of the Constitution. The patron of the program and Vice-Chancellor of the university was Prof. Ramesh Chandra Bhardwaj, the main speaker was Prof. Sanjeev Kumar Sharma, former Vice-Chancellor, Mahatma Gandhi Central University, Motihari, Bihar, the Academic Dean was Prof. Satya Prakash Dubey, the Registrar of the university was Dr. Brijpal, the coordinator of the program was Dr. Krishna Chandra Pandey, Head of the Department of Hindu Studies, and the moderator and co-coordinator was Dr. Govind Vallabh.</li>
            </ol>
            <h6 className="mb-2 mt-4 text-secondary">* Competitions -</h6>
            <ol className="list-group list-group-numbered">
                <li className="list-group-item bg-transparent border-0">On September 16, 2022, a slogan and writing competition on "Global Cooperation for Life Protection on Earth" was organized at Maharshi Valmiki Sanskrit University, Kaithal, on the occasion of World Ozone Day, in which 100 students participated. Students who secured first, second, and third positions were awarded certificates.</li>
                <li className="list-group-item bg-transparent border-0">On January 25, 2025, an essay competition on "Our Constitution, Our Pride" was held during the program, and participants were awarded certificates and prize money by the chief guest. The program concluded with the National Anthem. All heads of departments, professors, and students of the university were present on this occasion. The program was coordinated by Dr. Krishna Chandra Pandey, Head of the Department of Hindu Studies, and the moderator and co-coordinator was Dr. Govind Vallabh.</li>
            </ol>
            <h6 className="mb-2 mt-4 text-secondary">* Educational Tours -</h6>
            <ol className="list-group list-group-numbered">
                <li className="list-group-item bg-transparent border-0">Students from the Department of Hindu Studies and Research Department of Maharshi Valmiki Sanskrit University visited the famous ancient historical and cultural tourist sites of Haryana, Adibadri and Kapal Mochan pilgrimage sites in Yamunanagar district, under the guidance of Dr. Krishna Chandra Pandey, Coordinator and Head of the Department of Hindu Studies. Dr. Kuldeep and Dr. Sharmila also accompanied the students.</li>
                <li className="list-group-item bg-transparent border-0">On November 18, 2023, students from the Department of Hindu Studies were taken for an educational visit to the Shiv Kailash Green Energy Industrial Institute established in Guhla, Cheeka area, under the guidance of Dr. Krishna Chandra Pandey, Head of the Department of Hindu Studies, Dr. Sharmila, and Dr. Naveen Sharma.</li>
                <li className="list-group-item bg-transparent border-0">On April 23, 2025, a one-day educational tour for students of the Department of Hindu Studies was organized to Adibadrinath and Kapalmochan, Yamunanagar. The program was coordinated by Dr. Krishna Chandra Pandey, Head of the Department of Hindu Studies.</li>
            </ol>
        </div>
    ),
    "researchScholars": (
        <div>
            <p>There are no research scholars or students registered for the Vidya Varidhi (Ph.D.) degree currently.</p>
        </div>
    ),
    "achievements": (
        <div>
            <ul className="list-group list-group-flush">
                <li className="list-group-item bg-transparent border-0">In the academic year 2022-23, 31 students from the Department of Hindu Studies graduated, and in 2023-24, 19 students graduated.</li>
                <li className="list-group-item bg-transparent border-0">08 students from the Department of Hindu Studies qualified for the NET examination and 02 students qualified for the JRF examination, bringing honor to both the university and the Department of Hindu Studies.</li>
            </ul>
        </div>
    ),
    "contact": (
        <div>
            <h5 className="mb-3">Details of Academic Staff in the Department</h5>
            <div className="table-responsive">
                <table className="table table-bordered table-striped small mb-4">
                    <thead className="table-dark">
                        <tr>
                            <th>Sr. No.</th>
                            <th>Name</th>
                            <th>Designation</th>
                            <th>Phone</th>
                            <th>Email</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>Dr. Krishna Chandra Pandey</td>
                            <td>Head of Department, Hindu Studies (Regular)</td>
                            <td>98103-73278</td>
                            <td>hodhindustudies@mvsu.ac.in</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>Dr. Harish Kumar</td>
                            <td>Assistant Professor (Contractual)</td>
                            <td>79883-76657</td>
                            <td>rishibhawn@gmail.com</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <p className="mb-4 fw-bold">Part-time Assistant Professors in the Department - Currently none.</p>
            <h5 className="mb-3">Details of Non-Academic Staff in the Department</h5>
            <div className="table-responsive">
                <table className="table table-bordered table-striped small">
                    <thead className="table-dark">
                        <tr>
                            <th>Sr. No.</th>
                            <th>Employee Name</th>
                            <th>Designation</th>
                            <th>Phone</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1.</td>
                            <td>Kamal Anand</td>
                            <td>Typist</td>
                            <td>98026-00325</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
};

export default function DepartmentHinduStudies_Eng() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [activeContentId, setActiveContentId] = useState("about"); // Set initial content to "about" (Introduction)

    // Helper to find the display name of the active section
    const getActiveSectionName = () => {
        const activeDept = departments.find(dept => dept.id === activeContentId);
        return activeDept ? activeDept.name : "Department"; // Default to 'Department' if not found
    };

    const handleItemClick = (deptId) => {
        setActiveContentId(deptId);
        // Hide sidebar on click for small screens
        if (window.innerWidth < 768) {
            setShowSidebar(false);
        }
    };

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* Toggle Button for Small Screens */}
            <button
                className="btn btn-primary d-md-none m-2 shadow-sm"
                onClick={() => setShowSidebar(!showSidebar)}
                aria-label="Toggle Menu"
            >
                ☰ Menu
            </button>

            {/* Sidebar */}
            <aside className={`bg-white text-dark p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none"} d-md-flex col-md-3 border-end`}>
                <h5 className="text-center fw-bold mb-4 text-dark border-bottom pb-2">Department of Hindu Studies</h5>
                <nav className="flex-grow-1 overflow-auto pe-2"> {/* Added pe-2 for right padding on scrollbar */}
                    {departments.map((dept) => (
                        <p
                            key={dept.id} // Use unique ID for key
                            className={`mb-2 p-2 rounded small cursor-pointer transition-colors ${activeContentId === dept.id ? "bg-primary text-white shadow-sm" : "bg-light text-dark hover-effect"}`}
                            onClick={() => handleItemClick(dept.id)}
                            style={{
                                cursor: "pointer"
                            }}
                        >
                            {dept.name}
                        </p>
                    ))}
                </nav>
            </aside>

            {/* Main Content Area */}
            <main className="flex-grow-1 p-4 bg-white shadow col-md-9 overflow-auto">
                {/* Dynamic Header for the current section */}
                <h4 className="mb-3 text-primary text-center">{getActiveSectionName()}</h4>
                {/* Render content based on activeContentId */}
                {departmentContent[activeContentId] || <p className="text-muted">Please select a section.</p>}
            </main>

            {/* Inline CSS for transition effect and hover effect */}
            <style jsx>{`
                .transition-colors {
                    transition: background-color 0.3s ease, color 0.3s ease, box-shadow 0.3s ease;
                }
                .hover-effect:hover {
                    background-color: #e2e6ea !important; /* Lighter gray on hover for inactive items */
                    color: #000 !important;
                }
                .cursor-pointer {
                    cursor: pointer;
                }
            `}</style>
        </div>
    );
}